import { defineMessages } from "react-intl";

const PREFIX = "RegisterPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "Set password form",
  },
  changeButton: {
    id: `${PREFIX}.change`,
    defaultMessage: "Confirm",
  },
  newPassword: {
    id: `${PREFIX}.newPassword`,
    defaultMessage: "Password",
  },
  confirmPassword: {
    id: `${PREFIX}.confirmPassword`,
    defaultMessage: "Confirm Password",
  },
});
